module.exports = __webpack_public_path__ + "static/assets/4b3ec03f8b5153e8345374a8b4da6422.png";